'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ORGANISM_NAME = 'divider';

var Divider = function (_React$Component) {
  _inherits(Divider, _React$Component);

  function Divider() {
    _classCallCheck(this, Divider);

    return _possibleConstructorReturn(this, (Divider.__proto__ || Object.getPrototypeOf(Divider)).apply(this, arguments));
  }

  _createClass(Divider, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          config = _props.config,
          className = _props.className;
      var id = config.id,
          theme = config.theme;


      var sectionClasses = (0, _classnames2.default)(ORGANISM_NAME, className, theme);

      return _react2.default.createElement(
        'div',
        { className: sectionClasses, id: id },
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement('hr', { className: ORGANISM_NAME + '__color' })
        )
      );
    }
  }]);

  return Divider;
}(_react2.default.Component);

exports.default = Divider;


Divider.propTypes = {
  config: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    theme: _propTypes2.default.oneOf(['theme-background-color-white', 'theme-background-color-light'])
  }),
  className: _propTypes2.default.string
};

Divider.defaultProps = {
  config: {
    id: '',
    theme: 'theme-background-color-white'
  },
  className: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/divider/jsx/Divider.js
// module id = 572
// module chunks = 4